var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { timeoutPromise } from 'bernie-core';
import loadable from '@loadable/component';
import { getTrackingInfoForLogging } from '../common/logging-utils';
import { ActivitySort } from '../common/__generated__/api';
import { handleInvalidDates } from '../helpers/controller-date-helper';
var SERVER_CONTROLLER_FETCH = 15000;
var CLIENT_CONTROLLER_FETCH = 25000;
var ActivitySearchController = /** @class */function () {
  function ActivitySearchController() {
    this.pageId = 'page.LX-Search,A,20';
    this.pageName = 'page.LX-Search';
    this.path = '/:lang?/things-to-do/search';
    this.routeName = 'activity-search';
    /**
     * Components may be referred to directly
     *   `public component = ExamplePage;`
     *
     * Or, the preferred option is to create a code split point that will generate a new bundle.
     *   Use webpacks magic comments `webpackChunkName: "INSERT_FRIENDLY_NAME_HERE"`
     *   This will give it a friendly name for the name of the file.
     */
    // eslint-disable-next-line import/no-unresolved
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "search-page";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "search-page" */'views/activity-search-page');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/activity-search-page");
        }
        return eval('require.resolve')("views/activity-search-page");
      }
    });
    this.exact = true;
    this.caseSensitive = true;
    this.useV5RoutePaths_deprecated = true; // eslint-disable-line
    this.populateDefaultSortIfApplicable = function (searchCriteriaStore, query) {
      if (query && !query.sort) {
        query.sort = ActivitySort.RECOMMENDED;
      }
      searchCriteriaStore.populateDefaultSortIfApplicable();
    };
  }
  ActivitySearchController.prototype.fetch = function (options) {
    var _a, _b, _c;
    return __awaiter(this, void 0, Promise, function () {
      var stores, query, activitySearchStore, searchCriteriaStore, context, analyticsStore, experimentStore, page, isQueryKeysDifferent, isNewFetchRequired, isDateOrLocationChanged, searchVariables;
      return __generator(this, function (_d) {
        if (!options || !options.stores) {
          return [2 /*return*/, Promise.reject(new Error('ActivitiesSearch.fetch received invalid FetchOptions'))];
        }
        stores = options.stores, query = options.query;
        activitySearchStore = stores.get('activitySearchStore');
        searchCriteriaStore = stores.get('searchCriteriaStore');
        context = stores.get('context');
        analyticsStore = stores.get('analytics');
        experimentStore = stores.get('experiment');
        page = stores.get('page');
        activitySearchStore.query = query;
        activitySearchStore.serverSide = options.isServer;
        searchCriteriaStore.localDateFormat = context.localDateFormat;
        searchCriteriaStore.setExperimentStore(experimentStore);
        this.populateDefaultSortIfApplicable(searchCriteriaStore, query);
        isQueryKeysDifferent = query && searchCriteriaStore.isQueryKeysDifferent(query);
        isNewFetchRequired = isQueryKeysDifferent || activitySearchStore.searchError;
        if (isNewFetchRequired) {
          activitySearchStore.searchSetup();
          activitySearchStore.retainBrowserFocus = searchCriteriaStore.isSortOrFilterChanged(query);
          isDateOrLocationChanged = searchCriteriaStore.isDateOrLocationChanged(query);
          if (isDateOrLocationChanged) {
            searchCriteriaStore.resetQueryObject(query);
            this.populateDefaultSortIfApplicable(searchCriteriaStore, query);
          }
          if (!options.isServer && analyticsStore) {
            analyticsStore.resetAnalyticsForNewPage();
          }
          searchCriteriaStore.resetSearchCriteriaStore();
          searchCriteriaStore.setContext(context);
          searchCriteriaStore.searchQuery = query;
          searchCriteriaStore.searchQuery = handleInvalidDates(query, searchCriteriaStore.searchQuery, searchCriteriaStore.localDateFormat);
          activitySearchStore.resetActivitySearchStore();
          if (((_a = searchCriteriaStore.searchQuery) === null || _a === void 0 ? void 0 : _a.location) || ((_b = searchCriteriaStore.searchQuery) === null || _b === void 0 ? void 0 : _b.rid) || ((_c = searchCriteriaStore.searchQuery) === null || _c === void 0 ? void 0 : _c.landingPage)) {
            searchCriteriaStore.populateRegionTypeForLandingPage(query);
            searchVariables = searchCriteriaStore.searchVariables;
            return [2 /*return*/, timeoutPromise(Promise.all([activitySearchStore.fetchActivitiesSearchDestinationView(searchCriteriaStore, analyticsStore, query, searchVariables, this.pageId, null, true).then(function () {
              var _a, _b;
              if ((_b = (_a = activitySearchStore === null || activitySearchStore === void 0 ? void 0 : activitySearchStore.searchSummary) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.title) {
                page.title = activitySearchStore.searchSummary.pageInfo.title;
              }
            })]), options.isServer ? SERVER_CONTROLLER_FETCH : CLIENT_CONTROLLER_FETCH, "controller=search fetch=page timeout ".concat(getTrackingInfoForLogging(context)))];
          }
        }
        return [2 /*return*/, Promise.resolve()];
      });
    });
  };
  ActivitySearchController.prototype.fetchPageData = function () {
    return Promise.resolve({
      title: '',
      pageId: this.pageId,
      pageName: this.pageName
    });
  };
  return ActivitySearchController;
}();
export { ActivitySearchController };